import theme from '../../styles/themes/default';

export const selectStyle = {
  control: (styles: any) => ({
    ...styles,
    backgroundColor: theme.colors.white,
    width: '100%',
    height: '44px',
    boxShadow: 'none',
    outline: 'none',
    border: '1px solid',
    borderRadius: '8px',
    color: theme.colors.gray[400],
    padding: '0',
    '&:hover': {
      borderColor: theme.colors.orange.primary,
    },
    maxHeight: '44px',
    cursor: 'pointer',
    overflow: 'scroll',
  }),
  indicatorsContainer: (styles: any) => ({
    ...styles,
    maxHeight: '40px',
  }),
  multiValueContainer: (styles: any) => ({
    ...styles,
    border: '4px solid !important',
  }),
  multiValue: (styles: any) => ({
    ...styles,
    backgroundColor: theme.colors.gray[200],
    borderRadius: '14px',
  }),
  multiValueLabel: (styles: any) => ({
    ...styles,
    color: theme.colors.gray[600],
  }),
  multiValueRemove: (styles: any) => ({
    ...styles,
    color: theme.colors.gray[600],
    '&:hover': {
      color: theme.colors.gray[600],
    },
  }),
  container: (styles: any) => ({
    ...styles,
    width: '100%',
    outline: 'none',
    border: 'none',
    padding: '0',
    cursor: 'pointer',
  }),
  indicatorSeparator: (styles: any) => ({
    ...styles,
    display: 'none',
    border: 'none',
  }),
  option: (styles: any, { isSelected }: any) => ({
    ...styles,
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 400,
    gap: '8px',
    color: isSelected ? '#fff' : '#807E80',
    '&:hover': {
      backgroundColor: '#C1C1C1',
      color: '#fff',
      cursor: 'pointer',
    },
    '&:focus': {
      backgroundColor: '#C1C1C1',
      color: '#fff',
      cursor: 'pointer',
    },
    '&:checked': {
      backgroundColor: theme.colors.orange.primary,
      color: '#fff',
      cursor: 'pointer',
    },

    backgroundColor: isSelected ? theme.colors.orange.primary : '#fff',
  }),
  singleValue: (styles: any) => ({
    ...styles,
    color: '#807E80',
    fontSize: '14px',
  }),
  placeholder: (styles: any) => ({
    ...styles,
    fontSize: '14px',
    fontWeight: 700,
    color: theme.colors.gray[500],
    whiteSpace: 'nowrap',
  }),
};
